import React, { useEffect, useState } from 'react';
import AttachmentCard from './components/AttachmentCard';
import { fetchResources } from 'src/shared/services/src/lib/homeLearning';
import { ChildrenStoreData, ResourceDocumentResponseType, ResourceDocumentType } from 'src/shared/types/src';
import { useAppSelector } from '../../services/store';
import { getCurrentChild } from 'src/shared/redux-state/src';
import LocalImages from '../../static';
import { APP_MESSAGES } from 'src/shared/config/src';
import { AxiosError } from 'axios';
import { ResourceDocumentLoader } from 'src/app/components';
import HomeLearningBaseScreen from './HomeLearningBaseScreen';

const Resources = () => {
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    const [loading, setLoading] = useState<boolean>(false);
    const [resources, setResources] = useState<ResourceDocumentType[]>([]);
    const [errorMsg, setErrorMsg] = useState<string>(APP_MESSAGES.generalErrorMessage);


    useEffect(() => {
        init()
    }, []);

    const init = async () => {
        try {
            setLoading(true);

            const response = await fetchResources({
                child: currentChild,
            }) as ResourceDocumentResponseType;

            if (response && response.documents.length > 0) {
                setResources(response.documents)
            };

            setErrorMsg('');

        } catch (error) {
            if (error instanceof AxiosError) {
                // const apiError = error as AxiosError;
                const { errors } = error?.response?.data;
                if (errors && Object.keys(errors).length > 0) {
                    setErrorMsg(errors.length > 0 ? errors.join(',') : errors.join(", "));
                } else {
                    setErrorMsg(APP_MESSAGES.generalErrorMessage);
                };
            } else {
                setErrorMsg(APP_MESSAGES.generalErrorMessage);
            }

        } finally {
            setLoading(false);
        }
    }

    const renderEmptyData = () => {
        return (
            <div className='flex-1 d-flex flex-column justify-content-center align-items-center'>
                <div className='planning-no-data'>
                    <img src={LocalImages.noPlanning} alt="no planning" />
                    <p className='text-center fs-12 text-gray-300 mx-auto mt-3'>No resources and documents found.</p>
                </div>
            </div>
        )
    }

    const errorMessage = (errorMsg: any) => {
        return (
            <div className='flex-1 d-flex flex-column justify-content-center align-items-center'>
                <div className='planning-no-data'>
                    <img src={LocalImages.appErrorIcon} alt="Error" />
                    <p className='text-center fs-12 text-gray-300 mx-auto mt-3'>{errorMsg}</p>
                </div>
            </div>
        )
    }

    const renderDocuments = (item: ResourceDocumentType) => {
        return (
            <AttachmentCard
                title={item?.name}
                date={item?.created}
                description={item?.description}
                mimeType={item?.mimeType}
                type={item?.type}
                url={item?.url}
            />
        )
    }

    const renderLoader = () => {
        return (
            <ResourceDocumentLoader />
        )
    }

    if (loading) {
        return (
            <HomeLearningBaseScreen>
                <div className='mg-t-10'>
                    {
                        Array.from({ length: 8 }).map(_ => {
                            return renderLoader();
                        })
                    }
                </div>
            </HomeLearningBaseScreen>
        )
    };

    return (
        <HomeLearningBaseScreen>
            {
                resources.length ? resources.map(item => {
                    return renderDocuments(item)
                }) : renderEmptyData()
            }

            {errorMsg ? errorMessage(errorMsg) : null}
        </HomeLearningBaseScreen>
    )
};

export default Resources;